module.exports = __webpack_public_path__ + "img/high-code.c6b9d1a8.png";